import axios from '../../../utils/customAxiosUtil';

import qs from 'qs';

export const findAPI = {
  sendForId: async(param) => {
    return await axios.get(`api/acnt/crtfyhp/find/sendForId?memberName=${param.memberName}&hpno=${param.hpno}`);
  },

  getUserId: async(param) => {
    return await axios.get(`api/acnt/crtfyhp/find/findUserId?memberName=${param.memberName}&hpno=${param.hpno}`);
  },

  sendForPw: async(param) => {
    return await axios.get(`api/acnt/crtfyhp/find/sendForPw?userId=${param.userId}&hpno=${param.hpno}`);
  },

  updatePw: async(param) => { 
    return await axios.get(`api/acnt/crtfyhp/find/updatePw?userId=${param.userId}&hpno=${param.hpno}&newPw=${param.newPw}`);
  }
}